import { IInteractiveAccessObjectsInfo } from '@/@types/api/interactiveAccessObjects';
import { http } from '@/plugins/axios';

const endPoint = '/InteractiveAccessObjects';

/**
 * Возвращает список объектов доступа
 *
 * @param {accountId} id ID лицевого счета
 * @returns {Promise<IInteractiveAccessObjectsInfo>}
 */
export const getList = (id: number): Promise<IInteractiveAccessObjectsInfo> => {
  return http.get(`${endPoint}/List`, {
    params: { id },
  });
};

export const getWebCams = (params: {
  all: number;
  accountId: null | number;
}) => {
  return http.get(`Houses/WebCams`, {
    params,
  });
};

export const getScreenshot = (params: { id: number; cameraType: 0 }) => {
  return http.get(`Houses/Screenshot`, {
    params,
    responseType: 'blob',
  });
};

export const getStreamLink = (params: { id: number; cameraType: 0 }) => {
  return http.post(`Houses/GetStreamLink`, params);
};

export const activate = (params: { objectId: number }) => {
  return http.post(`${endPoint}/Activate`, params);
};
